<template>
<div>
<beautiful-chat
  :icons="icons"
  :participants="participants"
  :isOpen="isChatOpen"
  :close="closeChat"
  :open="openChat"
  :onMessageWasSent="onMessageWasSent"
  :colors="colors"
  :messageList="messageList"
  :alwaysScrollToBottom="alwaysScrollToBottom"
>
<template v-slot:header>
  <template v-if="!threadID">
    <div class="sc-header--title initial-title">
      {{auctionTitle}}<br /><small>Have a question regarding this listing? Chat directly with the trader.</small>
    </div>
  </template>
  <template v-else>
    <img :src="toImage" class="sc-header--img" />
    <div class="sc-header--title">{{toName}}<small v-if="toLocation"><br /><small>{{toLocation}}</small></small><small v-if="toPhone"><br /><small>{{toPhone}}</small></small><small v-if="toEmail"><br /><small>{{toEmail}}</small></small></div>
  </template>
</template>
<template v-slot:text-message-body="{ message }">
  {{message.data.text}}
  <small v-if="message.created"><br />{{moment(message.created.toDate()).format('LLL')}}</small>
</template>
</beautiful-chat>
<button ref="bleepAudioTrigger" style="display:none" @click="playBleep" />
</div>
</template>
<script>
import Vue from 'vue'
import firebase from 'firebase';
import { db } from '@/firebase';
import moment from 'moment';
import CloseIcon from 'vue-beautiful-chat/src/assets/close-icon.png'
import ChatIcon from '@/assets/chat.png'
import FileIcon from 'vue-beautiful-chat/src/assets/file.svg'
import CloseIconSvg from 'vue-beautiful-chat/src/assets/close.svg'
Vue.prototype.moment = moment;

export default {
  name: 'Chat',
  data() {
    return {
      to:null,
      mimic:false,
      threadID:null,
      auctionTitle:null,
      toImage:null,
      toName:null,
      toLocation:null,
      toPhone:null,
      toEmail:null,
      participants: [],
      isChatOpen:false,
      messageList: [],
      messageKeys: {},
      titleImageUrl: null,
      colors: {
        header: {
          bg: '#47AD16',
          text: '#fff'
        },
        launcher: {
          bg: '#47AD16'
        },
        messageList: {
          bg: '#fff'
        },
        sentMessage: {
          bg: '#47AD16',
          text: '#fff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#fff',
          text: '#212121'
        }
      },
      alwaysScrollToBottom:true,
      icons:{
        open:{
          img: ChatIcon,
          name: 'default',
        },
        close:{
          img: CloseIcon,
          name: 'default',
        },
        file:{
          img: FileIcon,
          name: 'default',
        },
        closeSvg:{
          img: CloseIconSvg,
          name: 'default',
        },
      },
    }
  },
  watch:{
    isChatOpen:function(){
      let vm = this;
      if(vm.isChatOpen&&!vm.mimic){
        let batch = db.batch();
        vm.messageList.forEach((message)=>{
          if(message.pending&&(vm.$config.FROM.id in message.pending)){
            let ref = db.collection("/messages").doc(message.id);
            batch.set(ref, {pending: firebase.firestore.FieldValue.delete()},{merge:true});
          }
        });
        let userRef = db.collection("/users").doc(vm.$config.FROM.id.toString());
        batch.set(userRef, {updatePending: true},{merge:true});
        batch.commit();
      }

    }
  },
  methods: {
    async onMessageWasSent (message) {
        let vm = this;
        message.author = this.$config.FROM.id;
        message.TO = this.$config.TO;
        message.FROM = this.$config.FROM;
        message.AUCTIONID = this.$config.AUCTIONID;
        if(!vm.threadID) {
          let threadData = {
            auctionID:vm.$config.AUCTIONID,
            auctionTitle:vm.$config.AUCTIONTITLE,
            participants:[vm.$config.FROM.id,vm.$config.TO.id],
            FROM:vm.$config.FROM,
            TO:vm.to,
            created:firebase.firestore.Timestamp.now()
          };
          if(vm.$config.AUCTIONIMAGE) threadData.auctionImage=vm.$config.AUCTIONIMAGE;
          let threadRef = await db.collection('/threads').add(threadData);
          vm.threadID=threadRef.id;
          vm.participants = [
            {
              id:((threadData.FROM.id==vm.$config.FROM.id)?threadData.TO.id:threadData.FROM.id),
              name:((threadData.FROM.id==vm.$config.FROM.id)?threadData.TO.name:threadData.FROM.name),
              imageUrl:((threadData.FROM.id==vm.$config.FROM.id)?threadData.TO.avatar:threadData.FROM.avatar)
            }
          ]
          vm.toName=((threadData.FROM.id==vm.$config.FROM.id)?threadData.TO.name:threadData.FROM.name);
          if(threadData.FROM.id==vm.$config.FROM.id){
              vm.toLocation=(threadData.TO.location?threadData.TO.location:null);
              vm.toPhone=(threadData.TO.phone?threadData.TO.phone:null);
              vm.toEmail=(threadData.TO.email?threadData.TO.email:null);
          }else{
              vm.toLocation=(threadData.FROM.location?threadData.FROM.location:null);
              vm.toPhone=(threadData.FROM.phone?threadData.FROM.phone:null);
              vm.toEmail=(threadData.FROM.email?threadData.FROM.email:null);
          }
          vm.toImage=((threadData.FROM.id==vm.$config.FROM.id)?threadData.TO.avatar:threadData.FROM.avatar);
        }
        await db.collection('/threads').doc(vm.threadID).update({
          pending:{[vm.$config.TO.id]:true},
          updated:firebase.firestore.Timestamp.now()
        });
        message.threadID=vm.threadID;
        message.pending={[vm.$config.TO.id]:true};
        message.created=firebase.firestore.Timestamp.now();
        db.collection('/messages').add(message).then((ref)=>{
          vm.messageKeys[ref.id]=true;
          message.author = (message.author==vm.$config.FROM.id?'me':message.author);
          vm.messageList = [ ...vm.messageList, message];
        });
      },
    openChat () {
      this.isChatOpen = true
      this.newMessagesCount = 0
    },
    closeChat () {
      this.isChatOpen = false
    },
    playBleep(){
      let bleep = new Audio('http://soundbible.com/mp3/Pling-KevanGC-1485374730.mp3');
      bleep.play();
    }
  },
  async created(){
    let vm = this;

    var url = window.location.pathname;
    var filename = url.substring(url.lastIndexOf('/')+1);

    if(window.VCHAT_FROM){
      vm.mimic = !(this.$config.FROM.id==window.VCHAT_FROM.id);
      this.$config.FROM = window.VCHAT_FROM;
    }

    if(this.$config.AVATAR) this.titleImageUrl=this.$config.AVATAR;
    if(this.$config.AUCTIONTITLE) this.auctionTitle=this.$config.AUCTIONTITLE;
    let threads = await db.collection('/threads')
    .where('auctionID','==',this.$config.AUCTIONID)
    .where('participants','array-contains',(filename=='_full.cfm'?this.$config.TO.id:this.$config.FROM.id))
    .get();
    if(!threads.empty){
      threads.forEach((thread)=>{
        vm.threadID=thread.id;
        let threadData = thread.data();
        vm.toName=((threadData.FROM.id==vm.$config.FROM.id)?threadData.TO.name:threadData.FROM.name);
        if(threadData.FROM.id==vm.$config.FROM.id){
            vm.toLocation=(threadData.TO.location?threadData.TO.location:null);
            vm.toPhone=(threadData.TO.phone?threadData.TO.phone:null);
            vm.toEmail=(threadData.TO.email?threadData.TO.email:null);
        }else{
            vm.toLocation=(threadData.FROM.location?threadData.FROM.location:null);
            vm.toPhone=(threadData.FROM.phone?threadData.FROM.phone:null);
            vm.toEmail=(threadData.FROM.email?threadData.FROM.email:null);
        }
        vm.toImage=((threadData.FROM.id==vm.$config.FROM.id)?threadData.TO.avatar:threadData.FROM.avatar);
        vm.to = threadData.FROM.id==vm.$config.FROM.id?threadData.TO:threadData.FROM;
        vm.participants = [
          {
            id:((threadData.FROM.id==vm.$config.FROM.id)?threadData.TO.id:threadData.FROM.id),
            name:((threadData.FROM.id==vm.$config.FROM.id)?threadData.TO.name:threadData.FROM.name),
            imageUrl:((threadData.FROM.id==vm.$config.FROM.id)?threadData.TO.avatar:threadData.FROM.avatar)
          }
        ]
      });
      let messages = await db.collection('/messages').where('threadID','==',vm.threadID).orderBy('created').get();
      if(!messages.empty) messages.forEach((message) => {
        let mData = message.data();
        mData.author = (mData.author==vm.$config.FROM.id?'me':mData.author);
        vm.messageList.push({id:message.id,...mData});
        vm.messageKeys[message.id]=true;
      });
      db.collection('/messages').where('threadID','==',vm.threadID).onSnapshot(function(snapshot) {
        snapshot.docChanges().forEach((message)=>{
          if (message.type === "added") {
            let doc = message.doc;
            let data = doc.data();
            if((data.TO.id==vm.$config.FROM.id)&&!(doc.id in vm.messageKeys)){
              vm.messageKeys[doc.id]=true;
              vm.messageList.push({id:doc.id,...data});
              vm.$refs.bleepAudioTrigger.click();
              db.collection("/users").doc(vm.$config.FROM.id.toString()).set({updatePending: true},{merge:true});
            }
          }
        });
      });
    }else{
      vm.to=vm.$config.TO;
    }
  },
  mounted(){}
}
</script>
<style>
.sc-header {min-height:auto !important;}
.sc-header--img {max-height:30px;background:white;}
.sc-header--close-button {display:none !important;}
.sc-header--title.initial-title {color:#ceff00 !important;font-weight:bold;}
.sc-header--title.initial-title small {color:white !important;font-weight:normal;}
</style>
